import { render, staticRenderFns } from "./SwordLayout.vue?vue&type=template&id=790a222f&scoped=true&"
import script from "./SwordLayout.vue?vue&type=script&lang=js&"
export * from "./SwordLayout.vue?vue&type=script&lang=js&"
import style0 from "./SwordLayout.vue?vue&type=style&index=0&id=790a222f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a222f",
  null
  
)

export default component.exports